module.exports = __webpack_public_path__ + "img/comentarios.4473a6cb.png";